import React from 'react';

import Header from './Header';
import Table from './Table';

export default class InvestmentTable extends React.Component {
  static Header = Header;
  static Table = Table;
}
